<template>
    <div class="page">
        <component
            :is="container"
            :title="$t('count.topicDetail')"
            :visible.sync="visible"
            :modal-append-to-body="false"
            top="10vh"
            width="700px"
            placement="right"
        >
            <div class="paper-item" :class="`paper-item-${topicInfo.id}`">
                <div class="detail">
                    <!-- 题干 -->
                    <div class="topic-title"  v-if="isTheory">
                        <p class="type">【{{topicTypeName[topicInfo.type]}}】</p>
                        <p class="topic" v-html="topicInfo.titleRT" style="font-size: 14px"></p>
                    </div>

                    <!-- 选项 -->
                    <ul v-if="topicInfo.type < 4">
                        <li v-for="(item, index) in topicInfo.options" class="topic-choice"
                            :key="index"
                            :class="{'rightAnswer': item.isRight}">
                            <el-radio v-if="topicInfo.type === 1" :label="index" v-model="item.isRight?index:''" class="option-item">
                                <em>{{item.tagName}}.</em>
                                <div class="options" v-html="item.titleRT"></div>
                            </el-radio>
                            <el-checkbox v-if="topicInfo.type === 2" v-model="item.isRight?true:false" class="option-item">
                                <em>{{item.tagName}}.</em>
                                <div class="options" v-html="item.titleRT"></div>
                            </el-checkbox>
                            <el-radio v-if="topicInfo.type === 3" :label="index" v-model="item.isRight?index:''" class="option-item">
                                <em>{{item.tagName}}</em>
                            </el-radio>
                        </li>
                    </ul>

                    <!-- 配对题 -->
                    <div class="image-topic" v-if="topicInfo.type == 4"  v-viewer="{movable: false}">
                        <div class="image-wrap">
                            <div class="image">
                                <img :src="topicInfo.picViewUrl ? topicInfo.picViewUrl : ''" alt="">
                            </div>
                            <ul class="option-wrap">
                                <li v-for="item in topicInfo.rectangleOptions" :key="'m'+item.id" class="option-item"> {{item.tagName + '. '+item.answerName}}</li>
                            </ul>
                        </div>
                    </div>

                    <!-- 图片题 -->
                    <div class="graphic-topic" v-if="topicInfo.type == 7"  v-viewer="{movable: false}">
                        <div class="image-area">
                            <div class="img-box">
                                <img :src="topicInfo.picSrcUrl" alt="考试图片">
                            </div>
                            <el-tag class="image-tag" type="primary" size="small">考试图片</el-tag>
                        </div>
                        <div class="image-area">
                            <div class="img-box">
                                <img :src="topicInfo.picViewUrl" alt="答案图片">
                            </div>
                            <el-tag v-if="topicInfo.isSafe" class="image-tag" type="success" size="mini" dark>答案图（安全）</el-tag>
                            <el-tag v-else class="image-tag" type="danger" size="mini">答案图（嫌疑）</el-tag>
                        </div>
                    </div>

                    <!-- CT、DR -->
                    <div class="image-topic" v-if="isImage"  v-viewer="{movable: false}">
                        <el-carousel indicator-position="outside" :autoplay="false" height="160px" trigger="click"
                                     :arrow="topicInfo.luggage.thumbnails.length>1? 'always':'never'">
                            <el-carousel-item v-for="(pItem,pIndex) in topicInfo.luggage.thumbnails" :key="pIndex">
                                <div class="carousel-wrap">
                                    <img :src="pItem.url" alt="">
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>

                    <div class="fiscan-topic" v-if="isFiscan">
                        <div class="img-wrap">
                            <img :src="topicInfo.url" alt="fiscan-image">
                            <div class="sign-area-list">
                                <li class="sign-area"
                                    v-for="item in topicInfo.marks"
                                    :style="{height: item.height*100+'%', width:item.width*100+'%', top:item.top*100+'%', left:item.left*100+'%'}"
                                    :key="item.tipId"
                                >
                                    <div class="tooltip sign-tip" :class="[item.left>0.65?'left':'right']">
                                        <div class="tooltip-arrow"></div>
                                        <div class="tooltip-inner">
                                            {{item.knowledgeName}}
                                        </div>
                                    </div>
                                </li>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="others" v-if="isTheory || isImage">
                    <a class="btn-answer" :class="{'active': tab === 1}" @click="tab = 1">{{$t('topic.answerAnalysis')}}</a>
                    <a class="btn-answer" :class="{'active': tab === 2}" v-if="isImage" @click="tab = 2" >{{$t('topic.imageDesc')}}</a>
                    <div class="answer-area">
                        <div v-if="tab === 1" class="desc" v-html="topicInfo.analysisRT||$t('c.none')"></div>
                        <div v-else-if="tab === 2 && isImage" class="desc">{{topicInfo.luggage.description==null ? $t('c.none'):topicInfo.luggage.description }}</div>
                    </div>
                </div>
            </div>
        </component>
    </div>
</template>

<script>
    export default {
        name: "StatsTopicView",
        props: {
            container: {
                type: String,
                default: 'el-dialog'
            },
            topicInfoVisible: {},
            topicInfo: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                visible: false,
                tab: 1,
                topicTypeName: {
                    1: this.$t('paper.single'),
                    2: this.$t('paper.multiple'),
                    3: this.$t('paper.trueOrFalse'),
                    4: this.$t('paper.matching'),
                    7: this.$t('paper.graphic'),
                }
            }
        },
        created() {

        },

        computed: {
            isTheory() {
                return [1, 2, 3, 4, 7].includes(this.topicInfo.type)
            },
            isImage() {
                return [5, 6].includes(this.topicInfo.type)
            },
            isFiscan() {
                return this.topicInfo.type === 8
            }
        },
        methods: {
            topicVisible(data) {
                if (data) {
                    this.visible = true
                }
            },

        },

    }
</script>

<style scoped lang="scss">
    .paper-item {
        padding: 10px;
        /*margin-bottom: 20px;*/
        background: #f6f7fb;
        //max-height: 500px;
        overflow: auto;
        .topic-title {
            display: flex;
            margin-bottom: 20px;
            .type {
                color: #f4516c;
                text-align: center;
            }

            p {
                display: inline-block;
                &:last-child {
                    flex: 1;
                }
            }
            .topic {
                font-size: 14px !important;
            }
        }

        .topic-choice {
            display: flex;
            margin-left: 25px;
            margin-bottom: 12px;

            em {
                line-height: 1.5;
                font-style: normal;
            }

            .options {
                display: inline-block;
                line-height: 1.5;
                margin-left: 3px;
            }
            .option-item:hover {
                cursor: inherit;
            }
        }

        .others {
            padding-left: 5px;
            .btn-answer {
                display: inline-block;
                cursor: inherit;
                color: #fff;
                background-color: #2d7eab;
                padding: 2px 5px;
                margin-bottom: 10px;
                margin-right: 10px;
                &.active{
                    background: #dee8f1;
                    color: #2d7eab;
                }
            }
            .answer-area {
                border-top: 1px solid #d8d8d8;
                padding: 8px 0;
            }
        }

        .el-carousel__item {
            text-align: center;
            vertical-align: middle;
            .carousel-wrap{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 250px;
                height: 100%;
                padding: 5px;
                border: 1px solid #ccc;
                box-shadow: 0 2px 4px -2px #999;
                cursor: pointer;
                margin: 0 auto;
                img{
                    max-width: 100%;
                    max-height: 100%;
                }
                &:hover{
                    border: 1px solid #00bcd4;
                }
            }
        }
        .image-wrap{
            display: flex;
            height: 160px;
            padding-left: 30px;
            margin-bottom: 15px;
            .image{
                width: 250px;
                height: 100%;
                padding: 5px;
                border: 1px solid #ccc;
                box-shadow: 0 2px 4px -2px #999;
                cursor: pointer;
                text-align: center;
                img{
                    max-width: 100%;
                    max-height: 100%;
                }
                &:hover{
                    border: 1px solid #00bcd4;
                }
            }
            .option-wrap{
                margin-top: 10px;
                margin-left: 20px;
                .option-item{
                    margin-bottom: 12px;
                }
            }
        }

        .graphic-topic {
            display: flex;
            margin-bottom: 10px;

            .image-area {
                flex: 1;
                position: relative;
                border: 1px solid #ccc;

                + .image-area {
                    margin-left: 20px;
                }

                .img-box {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
            }

            .image-tag {
                position: absolute;
                right: 0;
                top: 0;
            }

            .tips {
                font-size: 12px;
                color: #999;
                line-height: 2;
                transform: translateY(100%);
            }
        }


    }

    .fiscan-topic {
        .img-wrap {
            position: relative;
        }

        .sign-area{
            position: absolute;
            cursor: pointer;
            border:2px solid red;
            box-shadow: 0 0 0 1px #fff, 0 0 0 1px #fff inset, 1px 4px 10px 0 rgba(0,0,0,.1);
            .sign-tip {
                position: absolute;
                left: 100%;
                top: 50%;
                white-space: nowrap;
                margin: 0 5px;
                opacity: 1;
                z-index: auto;
                &.left{
                    left: auto;
                    right: 100%;
                }
            }
        }

        .tooltip {
            position: absolute;
            font-size: 12px;
            line-height: 1.42857143;
            opacity: 0;
            .tooltip-arrow {
                position: absolute;
                width: 0;
                height: 0;
                border-color: transparent;
                border-style: solid;
            }
            .tooltip-inner {
                position: relative;
                padding: 5px 24px 5px 6px;
                color: #fff;
                text-align: center;
                background-color: rgba(0, 0, 0, .5);
                border-radius: 4px;
            }
            &.right{
                padding: 0 5px;
                margin-left: 3px;
                .tooltip-arrow {
                    top: 50%;
                    left: 0;
                    margin-top: -5px;
                    border-width: 5px 5px 5px 0;
                    border-right-color: rgba(0, 0, 0, .5);
                }
            }
            &.left{
                padding: 0 5px;
                margin-left: -3px;
                .tooltip-arrow {
                    top: 50%;
                    right: 0;
                    margin-top: -5px;
                    border-width: 5px 0 5px 5px;
                    border-left-color: rgba(0, 0, 0, .5);
                }
                .tooltip-inner {
                    padding-right: 4px;
                    position: relative;
                }
            }
        }
    }
</style>
